
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import SexualityIntroductionCard from '~/components/organisms/SexualityIntroductionCard.vue'
import Card from '~/components/atoms/Card.vue'
import { Result } from '~/types/api/result'

export default Vue.extend({
  components: {
    SexualityIntroductionCard,
    Card,
  },
  props: {
    result: {
      type: Object,
      required: true,
    } as PropOptions<Result>,
  },
})
